import { makeStyles } from '@mui/styles';
import Grid from 'apollo-react/components/Grid';
import qs from 'query-string';
import React from 'react';

import RecordRevision from '../../components/RecordRevision';
import UserDataRecord from '../../components/UserDataRecord';
import { ENTITY_DISPLAY } from '../../constants/Urls';
import HyperLink from '../../form-designer/controls/ssHyperLink/HyperLinkComponent';
import { getUITA } from '../../utils/commonUtils';

const useStyles = makeStyles({
  header: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: 15,
    paddingLeft: 30,
    paddingBottom: 20,
    justifyContent: 'space-between',
  },
  title: {
    minHeight: '48px',
    fontFamily: 'Proxima Nova',
    fontSize: '32px',
    fontWeight: 600,
    lineHeight: 1,
    marginTop: '10px',
    marginRight: '15px',
    '& div': {
      display: 'inline',
      '& > a': {
        fontSize: 32,
      },
    },
  },
  buttonsContainer: {
    display: 'flex',
    marginRight: 14,
    marginTop: 10,
  },
});

const Header = ({
  docId,
  entityType,
  documentNumber,
  documentRevision,
  documentTitle,
  isPortalContent,
}) => {
  const classes = useStyles();

  const entityDisplayParams = { entityType, formKey: `${entityType}_DETAIL`, itmId: docId };

  const title = (
    <>
      <span ui-ta="RecordNumber">{documentNumber ?? ''}</span>
      {documentRevision && <RecordRevision revision={documentRevision} />}
    </>
  );

  return (
    <Grid container className={classes.header} ui-ta={getUITA('DocumentViewerHeader')}>
      <Grid item>
        <div className={classes.title}>
          {docId && !isPortalContent ? (
            <>
              <UserDataRecord
                recordNumber={documentNumber}
                revisionNumber={documentRevision}
                queryStringParams={entityDisplayParams}
                handleRecentEvent={false}
              />
              {documentNumber && (
                <HyperLink
                  pathname={ENTITY_DISPLAY}
                  queryString={qs.stringify(entityDisplayParams)}
                  text={title}
                  ui-ta={getUITA('DocumentViewerHeaderLink')}
                  ignoreRightMargin
                />
              )}
            </>
          ) : (
            <span>{title}</span>
          )}
          {documentTitle && (
            <>
              <span>{': '}</span>
              <span ui-ta={getUITA('DocumentViewerHeaderTitle')}>{documentTitle}</span>
            </>
          )}
        </div>
      </Grid>
      <div id="file-viewer-buttons-container" className={classes.buttonsContainer} />
    </Grid>
  );
};

export default Header;
